export const ANALYZE_RESUME_SUCCESS = "ANALYZE_RESUME_SUCCESS";
export const ANALYZE_RESUME_FAIL = "ANALYZE_RESUME_FAIL";
export const ANALYZE_RESUME_RESET = "ANALYZE_RESUME_RESET";
